import React from 'react';
import { SkillListWrapper, SkillItem, SkillItemContent, SkillItemIcon } from 'components/digitalNomad/SkillList.style.js';

const SkillList = (props) => {
  return (
    <SkillListWrapper>
        { props.skills.map((skill, i) => (
          <SkillItem key={i}>
            <SkillItemContent>
              <SkillItemIcon>
                <i className={skill.icon.classCode + ' fa-5x'} style={{color: skill.icon.color}}></i>
              </SkillItemIcon>
              <h3>{skill.title}</h3>
              <p>{skill.description}</p>
            </SkillItemContent>
          </SkillItem>
        ))}
    </SkillListWrapper>
  );
};

export default SkillList;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/SkillList.js